
/* 
 *  Hook para verificar que el token del usuario no haya expirado y
 *  aún sea válido.  Se debe llamar cada vez que se ingrese a una opción
 *  que requiera autentificación.
*/

import { useEffect } from 'react'
import { useValue } from '../context/ContextProvider'
import { jwtDecode } from 'jwt-decode'
import { useAppStore } from '../store/appStore.tsx';

const useCheckToken = () => {
    //console.log('---------->>> useCheckToken');
    const currentUser = useAppStore(appStore => appStore.currentUser);
    const updateUser = useAppStore(appStore => appStore.updateUser);
    const clearUser = useAppStore(appStore => appStore.clearUser);

    //const { state: { }, dispatch } = useValue();
    useEffect(() => {
        //console.log(currentUser);
        if (currentUser.id !== 0 ) {
            const decodedToken = jwtDecode(currentUser.token);
            //console.log("decodedToken.exp", decodedToken.exp*1000, " : ", new Date().getTime());
            if((decodedToken.exp*1000) > (new Date().getTime())) {
                //dispatch({type:'UPDATE_USER', payload:null})
                updateUser(currentUser)
            } else {
                //console.log("llamando a clearUser");
                clearUser();
            }
        }
    }, []);
}


export default useCheckToken